import {unbundledPriceTest} from './constants/signalmanConstants';

export default function fireUnbundledPriceTestEvent(location = 'plp catalog') {
  window.dataLayer.push({
    ab_test_group: unbundledPriceTest,
    ab_test_location: location,
    ab_test_name: '2025 05 27 unbundled price',
    event: 'ab_test_group'
  });
}
